export default [
  // {
  //   title: 'Dashboard',
  //   icon: 'HomeIcon',
  //   route: 'dashboard-analytics',
  // },
]
